import { render, staticRenderFns } from "./ArrowValue.vue?vue&type=template&id=693dfdb0&"
import script from "./ArrowValue.vue?vue&type=script&lang=ts&"
export * from "./ArrowValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports